import React from "react";
import classNames from "classnames";

import "./UserMenu.scss";

const UserMenu = ({ menu, onChangeSection }) => (
  <div id="user-menu">
    {menu.map((e, pos) => (
      <Item key={pos} obj={e} onChangeSection={onChangeSection} />
    ))}
  </div>
);

const Item = ({ obj, onChangeSection }) => (
  <div
    className={classNames("wrapper", { active: obj.active })}
    onClick={() => onChangeSection(obj.section)}
  >
    <div className="wrapper-icons">
      <i className={obj.fontAwesomeIconName}></i>
    </div>
  </div>
);

export default UserMenu;
